module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "video-control_select-wrap"
  }, [_vm._v("\n    Качество:\n    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.qualityValue),
      expression: "qualityValue"
    }],
    staticClass: "quality-select video-control_select default-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.qualityValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("Авто")]), _vm._v(" "), _vm._l((_vm.availableQuality), function(quality, level) {
    return _c('option', {
      key: level,
      domProps: {
        "value": level
      }
    }, [_vm._v(_vm._s(quality.name))])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30251d16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QualitySelect.vue
// module id = 90
// module chunks = 0